module.exports = __webpack_public_path__ + "img/Menu-07.8a735b3c.png";